import { useEffect, useRef, useState } from 'react';

export default function ErrorToastHost() {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  useEffect(() => {
    function onErr(ev) {
      const { label, detail } = ev.detail || {};
      const id = ++idRef.current;
      const extra =
        detail && detail.length ? safeStringify(detail.length === 1 ? detail[0] : detail) : '';
      setToasts((t) => [...t, { id, label: label || 'Error', detail: extra }]);
      setTimeout(() => {
        setToasts((t) => t.filter((x) => x.id !== id));
      }, 8000);
    }
    window.addEventListener('app-error', onErr);
    return () => window.removeEventListener('app-error', onErr);
  }, []);

  function dismiss(id) {
    setToasts((t) => t.filter((x) => x.id !== id));
  }

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        maxWidth: 420,
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          style={{
            background: '#fef2f2',
            border: '1px solid #fecaca',
            color: '#7f1d1d',
            borderRadius: 10,
            padding: '10px 12px',
            boxShadow: '0 10px 24px rgba(127, 29, 29, 0.18)',
            fontSize: '0.85rem',
            lineHeight: 1.35,
          }}
          role="alert"
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
            <span
              style={{
                display: 'inline-block',
                width: 18,
                height: 18,
                borderRadius: 4,
                background: '#dc2626',
                color: '#fff',
                textAlign: 'center',
                fontWeight: 700,
                fontSize: '0.72rem',
                lineHeight: '18px',
                flexShrink: 0,
              }}
            >
              !
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, wordBreak: 'break-word' }}>{t.label}</div>
              {t.detail && (
                <div
                  style={{
                    marginTop: 4,
                    fontSize: '0.75rem',
                    color: '#991b1b',
                    wordBreak: 'break-word',
                    maxHeight: 120,
                    overflow: 'auto',
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                  }}
                >
                  {t.detail}
                </div>
              )}
            </div>
            <button
              type="button"
              onClick={() => dismiss(t.id)}
              style={{
                border: 'none',
                background: 'transparent',
                color: '#7f1d1d',
                cursor: 'pointer',
                fontSize: '1rem',
                lineHeight: 1,
                padding: 0,
              }}
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

function safeStringify(v) {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (v instanceof Error) return `${v.name}: ${v.message}`;
  try {
    return JSON.stringify(v, (k, val) => (val instanceof Error ? `${val.name}: ${val.message}` : val), 2).slice(0, 600);
  } catch {
    return String(v).slice(0, 300);
  }
}
